export default __webpack_public_path__ + "static/media/social.bd2c5bab.svg";